import PageWithHero from "../components/legal/PageWithHero";
import useSEO from "../hooks/useSEO";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getLegalPage } from "../services/legalServices";

export default function PrivacyPage() {
  const { i18n, t } = useTranslation();
  const [page, setPage] = useState(null);
  const seo = useSEO({});

  useEffect(() => {
    let cancel = false;
    getLegalPage("privacy", i18n.language)
      .then((res) => {
        if (!cancel) setPage(res);
      })
      .catch(() => {
        if (!cancel) setPage(null);
      });
    return () => {
      cancel = true;
    };
  }, [i18n.language]);

  return (
    <>
      {seo}
      <PageWithHero
        title={page?.title || t("legalPages.privacy.title")}
        subtitle={page?.subtitle || t("legalPages.privacy.subtitle")}
      >
      {page?.bodyHtml ? (
        <div dangerouslySetInnerHTML={{ __html: page.bodyHtml }} />
      ) : (
        <p>{t("legalPages.dynamicFallback")}</p>
      )}
      </PageWithHero>
    </>
  );
}
